import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';

interface HeaderCellProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  disabled?: boolean;
}

export const TableHeaderCell: React.FC<HeaderCellProps> = props => {
  const { attributes, listeners, setNodeRef, isDragging, transform } = useSortable({
    id: props.id,
    disabled: props.disabled,
  });
  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition: 'none',
    ...props.style,
    ...(isDragging ? { position: 'relative', zIndex: 9999, userSelect: 'none' } : {}),
    display: 'flex',
    alignItems: 'center',
  };
  return (
    <div {...props} ref={setNodeRef} style={style} {...attributes}>
      <span
        {...listeners}
        style={{
          cursor: props.disabled ? 'default' : 'move',
          marginRight: '8px',
          opacity: props.disabled ? 0.5 : 1,
        }}
      >
        ::
      </span>
      {props.children}
    </div>
  );
};
